/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";
import {
  setConfigurationTypeImplementation,
  setFullScreenImplementation,
  setIsNewSessionIdImplementation,
  setLocaleImplementation,
  setSavedConfigurationsImplementation,
  setSessionIdFetchedImplementation,
  setUpdatingConfigurationImplementation
} from "../implementations/commonImplementation";
import { EVENTS_DATA } from "../data/commonData";

const initialState = {
  locale: "en-WW",
  eventsData: EVENTS_DATA,
  fullScreen: false,
  configurationType: null,
  sessionIdFetched: false,
  isNewSessionId: false,
  savedConfigurations: [],
  updatingConfiguration: false,
  updateConfiguration: false,
  showCancelDialogPopup: false,
  technologiesScope: null
};

export const common = createSlice({
  name: "common",
  initialState,
  reducers: {
    setLocale: (state, action) => {
      setLocaleImplementation(state, action);
    },
    setFullScreen: (state, action) => {
      setFullScreenImplementation(state, action);
    },
    setConfigurationType: (state, action) => {
      setConfigurationTypeImplementation(state, action);
    },
    setSessionIdFetched: (state, action) => {
      setSessionIdFetchedImplementation(state, action);
    },
    setIsNewSessionId: (state, action) => {
      setIsNewSessionIdImplementation(state, action);
    },
    setSavedConfigurations: (state, action) => {
      setSavedConfigurationsImplementation(state, action);
    },
    setUpdatingConfiguration: (state, action) => {
      setUpdatingConfigurationImplementation(state, action);
    },
    updateConfiguration: (state) => {
      state.updateConfiguration = !state.updateConfiguration;
    },
    setShowCancelDialogPopup: (state, action) => {
      state.showCancelDialogPopup = action.payload;
    },
    setTechnologiesScope: (state, action) => {
      state.technologiesScope = action.payload;
    },
    resetCommon: (state) => {
      const resetState = {
        ...initialState,
        locale: state.locale,
        eventsData: state.eventsData,
        sessionIdFetched: state.sessionIdFetched,
        isNewSessionId: state.isNewSessionId,
        technologiesScope: state.technologiesScope
      };
      return resetState;
    }
  }
});

export const {
  setLocale,
  setFullScreen,
  setConfigurationType,
  setSessionIdFetched,
  setIsNewSessionId,
  setSavedConfigurations,
  setUpdatingConfiguration,
  resetCommon,
  updateConfiguration,
  setShowCancelDialogPopup,
  setTechnologiesScope
} = common.actions;

export const selectLocale = (state) => state.common.locale;
export const selectEventsData = (state) => state.common.eventsData;
export const selectFullScreen = (state) => state.common.fullScreen;
export const selectConfigurationType = (state) => state.common.configurationType;
export const selectSessionIdFetched = (state) => state.common.sessionIdFetched;
export const selectIsNewSessionId = (state) => state.common.isNewSessionId;
export const selectSavedConfigurations = (state) => state.common.savedConfigurations;
export const selectUpdatingConfiguration = (state) => state.common.updatingConfiguration;
export const selectUpdateConfiguration = (state) => state.common.updateConfiguration;
export const selectShowCancelDialogPopup = (state) => state.common.showCancelDialogPopup;
export const selectTechnologiesScope = (state) => state.common.technologiesScope;

export default common.reducer;
